import SSNDisplay from 'components/SSNDisplay'
import dayjs from 'dayjs'
import React from 'react'

const Joint = ({ data }: any) => {
  const { secondary } = data()
  return (
    <>
      <div className="mt-4 text-left text-2xl font-semibold">Secondary Investor Details</div>
      <div className="mt-6">
        <div className="flex w-full justify-between">
          <div className="w-1/2">
            <h3 className="mb-2 text-lg font-medium uppercase">Basic Information</h3>
            <div className="pl-2">
              <div className="mb-2">
                <span className="mr-2 font-medium uppercase">Email:</span>
                {secondary.email}
              </div>
              <div className="mb-2">
                <span className="mr-2 font-medium uppercase">First Name:</span>
                {secondary.basicInfo.firstName}
              </div>
              <div className="mb-2">
                <span className="mr-2 font-medium uppercase">Middle Name:</span>
                {secondary.basicInfo.middleName}
              </div>
              <div className="mb-2">
                <span className="mr-2 font-medium uppercase">Last Name:</span>
                {secondary.basicInfo.lastName}
              </div>
              <div className="mb-2">
                <span className="mr-2 font-medium uppercase">Suffix:</span>
                {secondary.basicInfo.suffix}
              </div>
            </div>
            <h3 className="mb-2 text-lg font-medium uppercase">Address Information</h3>
            <div className="pl-2">
              <div className="mb-2">
                <span className="mr-2 font-medium uppercase">Country:</span>
                {secondary.addressInfo.country}
              </div>
              <div className="mb-2">
                <span className="mr-2 font-medium uppercase">State:</span>
                {secondary.addressInfo.state}
              </div>
              <div className="mb-2">
                <span className="mr-2 font-medium uppercase">Street Line 1:</span>
                {secondary.addressInfo.Street1}
              </div>
              <div className="mb-2">
                <span className="mr-2 font-medium uppercase">Street Line 2:</span>
                {secondary.addressInfo.Street2}
              </div>
              <div className="mb-2">
                <span className="mr-2 font-medium uppercase">City:</span>
                {secondary.addressInfo.city}
              </div>
              <div className="mb-2">
                <span className="mr-2 font-medium uppercase">Postal Code:</span>
                {secondary.addressInfo.postalCode}
              </div>
            </div>
          </div>
          <div className="w-1/2">
            <h3 className="mb-2 text-lg font-medium uppercase">Personal Information</h3>
            <div className="pl-2">
              <div className="mb-2">
                <span className="mr-2 font-medium uppercase">Phone Number:</span>
                {secondary.personalInfo.phoneNumber}
              </div>
              <div className="mb-2">
                <span className="mr-2 font-medium uppercase">Date of Birth:</span>
                <p>{String(dayjs(secondary.personalInfo.birthday).format('MM/DD/YYYY'))}</p>
              </div>
            </div>
            <h3 className="mb-2 text-lg font-medium uppercase">Financial Information</h3>
            <SSNDisplay ssn={secondary.financialInfo.ssn} />
          </div>
        </div>
      </div>
    </>
  )
}

export default Joint
